import { Skeleton } from '@/components/ui/skeleton';

import { ASSURANCE_LEVELS } from '../model';

const AssuranceTotalSkeleton = () => (
  <div className="space-y-2">
    <Skeleton className="h-8 w-32" />
    <Skeleton className="h-4 w-24" />
  </div>
);

const AssuranceBarSkeleton = () => (
  <li className="flex flex-col items-center gap-2">
    <Skeleton className="h-7 w-12" />
    <Skeleton className="h-50 w-14 rounded-xl" />
    <Skeleton className="size-6 rounded-full" />
    <div className="px-2 w-full">
      <Skeleton className="h-3 w-full" />
    </div>
  </li>
);

const AssuranceLevelRowSkeleton = () => (
  <li className="flex items-start gap-3 rounded-lg bg-slate-50 p-4">
    <Skeleton className="size-5 shrink-0 rounded-full" />
    <div className="grow space-y-1.5">
      <Skeleton className="h-3.5 w-24" />
      <Skeleton className="h-3 w-full" />
    </div>
  </li>
);

const AssuranceSummarySkeleton = () => (
  <div data-testid="assurance-summary-skeleton" className="space-y-6">
    <div className="grid grid-cols-2 divide-x divide-border">
      <AssuranceTotalSkeleton />
      <div className="pl-6">
        <AssuranceTotalSkeleton />
      </div>
    </div>
    <div className="space-y-4">
      <Skeleton className="h-3 w-64" />
      <ul className="grid grid-cols-3 gap-2">
        {ASSURANCE_LEVELS.map(({ key }) => (
          <AssuranceBarSkeleton key={key} />
        ))}
      </ul>
    </div>
    <ul className="space-y-2">
      {ASSURANCE_LEVELS.map(({ key }) => (
        <AssuranceLevelRowSkeleton key={key} />
      ))}
    </ul>
  </div>
);

export default AssuranceSummarySkeleton;
